<template>
  <q-expansion-item
    expand-separator
    :default-opened="defaultOpened"
    :icon="icon"
    :label="label"
    :header-class="headerClass"
    :header-inset-level="headerInsetLevel"
  >
    <slot />
  </q-expansion-item>
</template>

<script>
export default {
  name: 'ItemExpandable',
  props: {
    icon: String,
    label: String,
    headerClass: String,
    defaultOpened: Boolean,
    headerInsetLevel: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped></style>
